import createReducer from "@utils/createReducer";
import * as types from "../types/index";
import { logout } from "@utils/api.config";

const initialState = {
  isLoading: false,
  successMessage: null,
  errorMessage: null,
  hmskTemplateList: {},
  hmskTemplateData: {},
  templatesForHours: {},
};

export const hmskTemplateReducer = createReducer(initialState, {
  [types.ADD_HMSK_TEMPLATE](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      successMessage: null,
      errorMessage: null,
    });
  },
  [types.ADD_HMSK_TEMPLATE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      successMessage: action.payload,
      errorMessage: null,
    });
  },
  [types.ADD_HMSK_TEMPLATE_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      isLoading: false,
      successMessage: null,
      errorMessage: action.payload,
    });
  },
  [types.GET_HMSK_TEMPLATES](state) {
    return Object.assign({}, state, {
      hmskTemplateList: {},
      errorMessage: null,
      isLoading: true,
    });
  },
  [types.GET_HMSK_TEMPLATES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      hmskTemplateList: action.payload,
      isLoading: false,
    });
  },
  [types.GET_HMSK_TEMPLATES_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      errorMessage: action.payload,
      isLoading: false,
    });
  },
  [types.GET_HMSK_TEMPLATE](state) {
    return Object.assign({}, state, {
      ...state,
      hmskTemplateData: {},
      isLoading: true,
      successMessage: null,
      errorMessage: null,
    });
  },
  [types.GET_HMSK_TEMPLATE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      hmskTemplateData: action.payload,
      isLoading: false,
    });
  },
  [types.GET_HMSK_TEMPLATE_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      errorMessage: action.payload,
      isLoading: false,
    });
  },
  [types.UPDATE_HMSK_TEMPLATE](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      successMessage: null,
      errorMessage: null,
    });
  },
  [types.UPDATE_HMSK_TEMPLATE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      successMessage: action.payload,
      errorMessage: null,
      isLoading: false,
    });
  },
  [types.UPDATE_HMSK_TEMPLATE_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      successMessage: null,
      errorMessage: action.payload,
      isLoading: false,
    });
  },
  [types.DELETE_HMSK_TEMPLATE](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      successMessage: null,
      errorMessage: null,
    });
  },
  [types.DELETE_HMSK_TEMPLATE_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      successMessage: action.payload,
      errorMessage: null,
      isLoading: false,
    });
  },
  [types.DELETE_HMSK_TEMPLATE_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...initialState,
      successMessage: null,
      errorMessage: action.payload,
      isLoading: false,
    });
  },
  [types.COPY_HMSK_TEMPLATES](state) {
    return Object.assign({}, state, {
      ...state,
      isLoading: true,
      successMessage: null,
      errorMessage: null,
    });
  },
  [types.COPY_HMSK_TEMPLATES_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      successMessage: action.payload,
      errorMessage: null,
    });
  },
  [types.COPY_HMSK_TEMPLATES_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      isLoading: false,
      successMessage: null,
      errorMessage: action.payload,
    });
  },
  [types.GET_TEMPLATES_FOR_CHECKOUT](state) {
    return Object.assign({}, state, {
      ...state,
      templatesForHours: {},
      errorMessage: null,
      isLoading: true,
    });
  },
  [types.GET_TEMPLATES_FOR_CHECKOUT_SUCCESS](state, action) {
    return Object.assign({}, state, {
      ...state,
      templatesForHours: action.payload,
      isLoading: false,
    });
  },
  [types.GET_TEMPLATES_FOR_CHECKOUT_FAILURE](state, action) {
    if (action.payload.status === 401) {
      logout();
    }
    return Object.assign({}, state, {
      ...state,
      errorMessage: action.payload,
      isLoading: false,
    });
  },
  ["RESET_HMSK_TEMPLATE_LIST"](state, _) {
    return Object.assign({}, state, {
      ...state,
      hmskTemplateList: {},
    });
  },
});
